/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Readiness_Stress_InvalidInputs */

const en_us2_workout_readiness_stress_invalid = /** @type {(inputs: Workout_Readiness_Stress_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That answer about your stress is not valid. Answer it again.`)
};

const pt_br2_workout_readiness_stress_invalid = /** @type {(inputs: Workout_Readiness_Stress_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa resposta sobre o seu estresse não é válida. Responda de novo.`)
};

const es_419_workout_readiness_stress_invalid = /** @type {(inputs: Workout_Readiness_Stress_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esa respuesta sobre tu estrés no es válida. Respóndela de nuevo.`)
};

const pt_pt2_workout_readiness_stress_invalid = /** @type {(inputs: Workout_Readiness_Stress_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa resposta sobre o teu stress não é válida. Responde de novo.`)
};

const fr_fr2_workout_readiness_stress_invalid = /** @type {(inputs: Workout_Readiness_Stress_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette réponse sur ton stress n'est pas valide. Réponds de nouveau.`)
};

const de_de2_workout_readiness_stress_invalid = /** @type {(inputs: Workout_Readiness_Stress_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Antwort zu deinem Stress ist ungültig. Beantworte die Frage erneut.`)
};

const it_it2_workout_readiness_stress_invalid = /** @type {(inputs: Workout_Readiness_Stress_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa risposta sul tuo stress non è valida. Rispondi di nuovo.`)
};

/**
* | output |
* | --- |
* | "That answer about your stress is not valid. Answer it again." |
*
* @param {Workout_Readiness_Stress_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_readiness_stress_invalid = /** @type {((inputs?: Workout_Readiness_Stress_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Readiness_Stress_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_readiness_stress_invalid(inputs)
	if (locale === "es-419") return es_419_workout_readiness_stress_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_readiness_stress_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_readiness_stress_invalid(inputs)
	if (locale === "de-DE") return de_de2_workout_readiness_stress_invalid(inputs)
	if (locale === "it-IT") return it_it2_workout_readiness_stress_invalid(inputs)
	return en_us2_workout_readiness_stress_invalid(inputs)
});
export { workout_readiness_stress_invalid as "workout.readiness_stress_invalid" }